import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { fetchEventsLast60, fetchOrdersLast60 } from '../../actions';
import { XYPlot, XAxis, YAxis, LineSeries, DiscreteColorLegend } from 'react-vis';

const propTypes = {
    events: PropTypes.any,
    orders: PropTypes.any,
  }
  
  class OrderChart extends React.Component {
    constructor(props) {
      super(props)
      autoBind(this)
    }
    componentDidMount() {
      this.props.dispatch(fetchEventsLast60())
      this.props.dispatch(fetchOrdersLast60())
    }
    componentWillMount() {
      //  this.props.dispatch(clearAuthErrors());
      setInterval(() => {
        this.props.dispatch(fetchEventsLast60())
        this.props.dispatch(fetchOrdersLast60())
        this.setState({
          timeLineTop: this.state.timeLineTop + 1
        })
      }, 60000)
    }
    render() {
        if (this.props.events && this.props.events.event && this.props.events.event.results
            && this.props.orders && this.props.orders.order && this.props.orders.order.results) {
            // var options = { timeZone: "America/New_York"}; 
            const events = this.props.events.event.results;
            const orders = this.props.orders.order.results;
            if(orders.length===0 && events.length===0){
                return(
                    <p>No new orders in last 6 hrs</p>
                )
            }
            let displayData, OrderData;
            var ITEMS = []
            if(events) {
                displayData = events.map(e => {
                    // console.log("Submissions ------>",e.cnt, e.intervalAlias, new Date(e.intervalAlias).toLocaleString("en-US", options));
                    return ({ y: parseInt(e.cnt), x: new Date(e.intervalAlias) })
                })
                ITEMS.push({ title: 'Emails', color: '#cccccc', strokeWidth: 2 })
            }
            if(orders){
                OrderData = orders.map(e => {
                    // console.log("Orders ------>",e.cnt, e.intervalAlias );
                    return ({ y: parseInt(e.cnt), x: new Date(e.intervalAlias) })
                })
                ITEMS.push({ title: 'Orders', color: '#06bcd4' })
            }

            return (
                <XYPlot 
                    xType="time"
                    width={300}
                    height={300}
                    opacity = {1} >
                    <XAxis />
                    <YAxis />
                    {events &&
                        <LineSeries data={displayData} style={{strokeWidth: 2}} color="#cccccc" />
                    }
                    {orders &&
                        <LineSeries data={OrderData} color="#06bcd4" />
                    }
                    <DiscreteColorLegend orientation="horizontal" width={300} items={ITEMS} />
                </XYPlot>        
            );
        } else {
            return (
                <p>Loading...</p>
            )
        }
    }
}

OrderChart.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    events: state.events,
    orders: state.orders,
  };
}

export default connect(mapStateToProps)(OrderChart);



// WEBPACK FOOTER //
// ./src/components/OrderChart/index.js